// Messages for operator/QuoteRequests (auto-merged by lib/i18n.ts).
export const en = {
  'operator.quote_requests.head': 'Quote requests — Operator',
  'operator.quote_requests.title': 'Quote requests',
  'operator.quote_requests.desc':
    'Inbound RFQs from the portal and the website — convert one into a quote.',
  'operator.quote_requests.empty': 'No open requests. New RFQs land here.',
  'operator.quote_requests.source.portal': 'Portal',
  'operator.quote_requests.source.public': 'Website',
  'operator.quote_requests.convert': 'Convert',
  'operator.quote_requests.dismiss': 'Dismiss',
  'operator.quote_requests.dismiss_title': 'Dismiss this request?',
  'operator.quote_requests.dismiss_body':
    'It will be removed from the inbox. This keeps a record but takes no further action.',
}

export const zhTW = {
  'operator.quote_requests.head': '報價申請 — 營運端',
  'operator.quote_requests.title': '報價申請',
  'operator.quote_requests.desc': '來自客戶入口與網站的詢價 — 可轉換為報價。',
  'operator.quote_requests.empty': '目前沒有待處理的申請。新的詢價會顯示於此。',
  'operator.quote_requests.source.portal': '客戶入口',
  'operator.quote_requests.source.public': '網站',
  'operator.quote_requests.convert': '轉換',
  'operator.quote_requests.dismiss': '忽略',
  'operator.quote_requests.dismiss_title': '要忽略此申請嗎？',
  'operator.quote_requests.dismiss_body': '它會從收件匣移除。仍會保留紀錄，但不再進一步處理。',
}
